export default __webpack_public_path__ + "static/og_image-8e56caa3dc1d12914b8925db43aee110.jpg";